import { Routes } from '@angular/router';

import { AuthGuard } from '../auth.guard';
import { RootComponent } from '../root/root.component';
import { ListComponent } from './list/list.component';
import { BidLogComponent} from './bid-log/bid.log.component';
import { LeadSourceComponent } from './lead-source/lead.source.component';
import { CustomerSummaryComponent } from './customer-summary/customer.summary.component';
import { LostQuoteComponent } from './lost-quote/lost.quote.component';
import { DealerEngagementComponent } from './dealer-engagement/dealer.engagement.component';
import { DealerLicensureComponent } from './dealer-licensure/dealer-licensure.component';
import { PayrollSummaryComponent } from './payroll-summary/payroll-summary.component';
import { JobCostComponent } from './job-cost/job-cost.component';
import { EmailLogComponent } from './email-log/email.log.component';
import { DealerContactComponent } from './dealer-contact/dealer-contact.component';
import { CustomerMetricComponent } from './customer-metric/customer-metric.component';
import { InventoryComponent } from './inventory/inventory.component';
import { DealersLatestLoginComponent } from './dealers-latest-login/dealers-latest-login.component';
import { MessageLogComponent } from './message-log/message.log.component';

export const routing: Routes = [
  {
    path: 'report',
    data: {
      breadcrumb_en: 'Reports',
      breadcrumb_es: 'Informes'
    },
    component: RootComponent, canActivate: [AuthGuard],

    children: [
      {
        path: '', component: ListComponent,
        data: {
          breadcrumb_en: 'Report List',
          breadcrumb_es: 'Lista de Informes'
        },
      },
      {
        path: 'bidlog', component: BidLogComponent,
        data: {
          breadcrumb_en: 'Bid Log Report',
          breadcrumb_es: 'Informe de registro de ofertas'
        },
      },
      {
        path: 'leadsource', component: LeadSourceComponent,
        data: {
          breadcrumb_en: 'Lead Source Report',
          breadcrumb_es: 'Cotizaciones por fuente principal '
        },
      },
      {
        path: 'customersummary', component: CustomerSummaryComponent,
        data: {
          breadcrumb_en: 'Customer Summary Report',
          breadcrumb_es: 'Informe de Cotización y Contracto del Cliente'
        },
      },
      {
        path: 'lostquote', component: LostQuoteComponent,
        data: {
          breadcrumb_en: 'Lost Quote Report',
          breadcrumb_es: 'Análisis de cotizaciones perdidas'
        },
      },
      {
        path: 'jobcost', component: JobCostComponent,
        data: {
          breadcrumb_en: 'Job Costing Report',
          breadcrumb_es: 'Informe de costos de trabajo'
        },
      },
      {
        path: 'payrollsummary', component: PayrollSummaryComponent,
        data: {
          breadcrumb_en: 'Payroll Summary Report',
          breadcrumb_es: 'Informe de Resumen de Nómina'
        },
      },
      {
        path: 'dealercontact', component: DealerContactComponent,
        data: {
          breadcrumb_en: 'Dealer Contact Report',
          breadcrumb_es: 'Dealer Contact Report'
        },
      },
      {
        path: 'dealerengagement', component: DealerEngagementComponent,
        data: {
          breadcrumb_en: 'Dealer Engagement Report',
          breadcrumb_es: 'Dealer Engagement Report'
        },
      },
      {
        path: 'dealerlicensure', component: DealerLicensureComponent,
        data: {
          breadcrumb_en: 'Dealer Licensure Report',
          breadcrumb_es: 'Dealer Licensure Report'
        },
      },
      {
        path: 'dealerlogin', component: DealersLatestLoginComponent,
        data: {
          breadcrumb_en: 'Dealer Login Report',
          breadcrumb_es: 'Dealer Login Report'
        },
      },
      {
        path: 'customermetric', component: CustomerMetricComponent,
        data: {
          breadcrumb_en: 'Customer Metric Report',
          breadcrumb_es: 'Customer Metric Report'
        },
      },
      {
        path: 'emailLog', component: EmailLogComponent,
        data: {
          breadcrumb_en: 'Email Log Report',
          breadcrumb_es: 'Email Log Report'
        },
      },
      {
        path: 'smsMessageLog', component: MessageLogComponent,
        data: {
          breadcrumb_en: 'SMS Log Report',
          breadcrumb_es: 'SMS Log Report'
        },
      },
      {
        path: 'inventory', component: InventoryComponent,
        data: {
          breadcrumb_en: 'Inventory Report',
          breadcrumb_es: 'Inventory Report'
        },
      },
    ]
  }
];
